const nbsp = String.fromCharCode(160);

/**
 * Converts number (float or integer) to formatted string.
 * Should work the same way on IE11/Node as it does on modern browsers for DKK currency.
 * Ex: 20 -> '20,00 kr.'
 * Ex: -3319.51962 -> '-3.319,52 kr.'
 * @param value float or integer
 * @param locale Ex: 'da-DK'
 * @param currencyCode Ex: 'DKK'
 * @param style
 */
export const formatCurrency = (
    value: number,
    locale: string = 'da-DK',
    currencyCode: string = 'DKK',
    style: 'decimal' | 'currency' | 'percent' | 'unit' = 'currency'
): string => {
    let internationalized = new Intl.NumberFormat(locale, { style, currency: currencyCode }).format(value);
    if (currencyCode === 'DKK') {
        if (style !== 'currency') {
            return internationalized;
        }
        const isNegative = internationalized[0] === '-';
        if (isNegative) {
            internationalized = internationalized.substr(1);
        }
        const beginning = internationalized.substr(0, 4);
        if (beginning.match(/DKK\s/) || beginning.match(/kr.\s/)) {
            internationalized = `${internationalized.substr(4)}${nbsp}kr.`;
        }
        internationalized = internationalized.replace(/\,/g, '.');
        internationalized = `${internationalized.substr(0, internationalized.length - 7)},${internationalized.substr(
            internationalized.length - 6
        )}`;
        if (isNegative) {
            internationalized = `-${internationalized}`;
        }
    }
    return internationalized;
};
